import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c76f4d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "FTLBidState" }
const _hoisted_2 = { class: "FTLBidState__container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "container__text" }, "Загрузка FTL заявки...", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "container__text text-red-500" }, " При получении FTL заявки произошла ошибка ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_loader, { class: "primary" }),
            _hoisted_3
          ], 64))
        : (_ctx.isFailed)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _hoisted_4,
              _createVNode(_component_the_button, {
                class: "small primary",
                onClick: _ctx.onRetry
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Повторить ")
                ]),
                _: 1
              }, 8, ["onClick"])
            ], 64))
          : _createCommentVNode("", true)
    ])
  ]))
}